module.exports = __webpack_public_path__ + "heart-blueprint-chocolate-ice-cream.07839f0258998900d2dc.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/heart-blueprint-chocolate-ice-cream.svg
// module id = ../../../../../src/assets/img/heart-blueprint-chocolate-ice-cream.svg
// module chunks = main